















import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GlobalMenuItem extends Vue {
  @Prop({ default: null }) public to!: string;
  @Prop() public caption!: string;
  @Prop() public selector!: string;
  @Prop() public icon?: string;
  @Prop({ default: null }) public perm: string;
  @Prop({default: null}) public tooltip: string;

  public isActive(path: string) {
    if (path === '/') {
      return this.$route.path === path;
    } else {
      return this.$route.path.startsWith(path);
    }
  }
  public onClick(){
      this.$emit("click");
  }
  public mounted() {
    if(this.tooltip) this.$nextTick(() => {
      if (this.$refs.tooltip_target == null) return;
      this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);
    });
  }
}
